<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-select
                          v-model="filters.accmType"
                          :label="labels.accmType"
                          :items="accumtypes"
                          item-text="label"
                          item-value="value"
                          :error-messages="errors.collect('accmType')"
                          data-vv-name="accmType"
                          :data-vv-as="labels.accmType"
                          v-validate="'name'"
                        ></v-select>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field
                          v-model="filters.fact1Val"
                          :label="labels.fact1Val"
                          :error-messages="errors.collect('fact1Val')"
                          data-vv-name="fact1Val"
                          :data-vv-as="labels.fact1Val"
                          v-validate="'max:8'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field
                          v-model="filters.fact2Val"
                          :label="labels.fact2Val"
                          item-text="label"
                          item-value="value"
                          data-vv-name="fact2Val"
                          :data-vv-as="labels.fact2Val"
                          :error-messages="errors.collect('fact2Val')"
                          clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field
                          v-model="filters.fact3Val"
                          :label="labels.fact3Val"
                          item-text="label"
                          item-value="value"
                          data-vv-name="fact3Val"
                          :data-vv-as="labels.fact3Val"
                          :error-messages="errors.collect('fact3Val')"
                          clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field
                          v-model="filters.limType"
                          :label="labels.limType"
                          item-text="label"
                          item-value="value"
                          data-vv-name="limType"
                          :data-vv-as="labels.limType"
                          :error-messages="errors.collect('limType')"
                          clearable
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="doNew">
          New Retention Limit
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-flex>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :server-items-length="totalItems"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.accmType }}</td>
                <td class="text-xs-left">{{ row.item.fact1Val }}</td>
                <td class="text-xs-left">{{ row.item.fact2Val }}</td>
                <td class="text-xs-left">{{ row.item.fact3Val }}</td>
                <td class="text-xs-left">{{ row.item.limType }}</td>
                <td class="text-xs-left">{{ row.item.effDateDisp }}</td>
                <td class="text-xs-left">{{ row.item.ownRtn }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReview(row.item)"
                    remove
                    @remove="doPromptRemove(row.item)"
                    query
                    @query="doQuery(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the selected Retention Limit ?</p>
        <div class="queryValue">
          {{ selectedRtnLim.accmType }} - Factor 1: {{ selectedRtnLim.fact1Val }}, Factor 2: {{ selectedRtnLim.fact2Val }}, Factor 3:
          {{ selectedRtnLim.fact3Val }}
        </div>
      </confirm>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { formatDisplayDate } from '@/utils/date'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonMixins } from '@/mixins/common/commonMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Accumulation Type', value: 'accmType' },
        { text: 'Factor 1', value: 'fact1Val' },
        { text: 'Factor 2', value: 'fact2Val' },
        { text: 'Factor 3', value: 'fact3Val' },
        { text: 'Limit Type', value: 'limType' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Own Retention', value: 'ownRtn' },
        TableConst.tableActionHeader
      ],
      labels: {
        accmType: 'Accumulation Type',
        fact1Val: 'Factor 1 Value',
        fact2Val: 'Factor 2 Value',
        fact3Val: 'Factor 3 Value',
        limType: 'Limit Type',
        effDate: 'Effective Date',
        ownRtn: 'Own Retention'
      },
      filters: {
        accmType: undefined,
        fact1Val: undefined,
        fact2Val: undefined,
        fact3Val: undefined,
        limType: undefined
      },
      select: undefined,
      selectedRtnLim: {
        accmType: undefined,
        fact1Val: undefined,
        fact2Val: undefined,
        fact3Val: undefined,
        limType: undefined,
        effDate: undefined
      },
      promptRemove: false,
      accumtypes: [],
      items: [],
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
    this.getCommonDataList('accumtypes')
  },
  methods: {
    formatDisplayDate(effDate) {
      return formatDisplayDate(effDate)
    },
    async doInit() {
      const apiUrl = this.$store.state.rtnLimParam.menu.getRtnLimPage

      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((rtnLim) => {
                const convertList = {
                  accmType: rtnLim.accmType,
                  fact1Val: rtnLim.fact1Val,
                  fact2Val: rtnLim.fact2Val,
                  fact3Val: rtnLim.fact3Val,
                  limType: rtnLim.limType,
                  effDate: rtnLim.effDate,
                  effDateDisp: formatDisplayDate(rtnLim.effDate),
                  ownRtn: rtnLim.ownRtn,
                  remark: rtnLim.remark,
                  createdName: rtnLim.createdName,
                  createdDate: formatDisplayDate(rtnLim.createdDate),
                  modifiedName: rtnLim.modifiedName,
                  modifiedDate: formatDisplayDate(rtnLim.modifiedDate)
                }
                this.items.push(convertList)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    doNew() {
      this.$router.push({
        name: 'rtnLimDet',
        params: {
          rtnLim: 'new'
        }
      })
    },
    doReview(rtnLim) {
      if (rtnLim) {
        this.$router.push({
          name: 'rtnLimDet',
          params: {
            rtnLim
          }
        })
      }
    },
    async doDelete() {
      if (this.selectedRtnLim.accmType) {
        const apiUrl = this.$store.state.rtnLimParam.menu.deleteRtnLim
        if (apiUrl) {
          const expand = this.selectedRtnLim
          this.$http
            .post(apiUrl, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doQuery(rtnLim) {
      if (rtnLim) {
        this.$router.push({
          name: 'rtnLimDet',
          params: {
            rtnLim: rtnLim,
            isQueryRtnLim: 'true'
          }
        })
      }
    },
    doPromptRemove(rtnLim) {
      this.resetMessages()
      if (rtnLim) {
        const apiUrl = this.$store.state.rtnLimParam.menu.checkDeleteRtnLim
        if (apiUrl) {
          const expand = {
            accmType: rtnLim.accmType,
            fact1Val: rtnLim.fact1Val,
            fact2Val: rtnLim.fact2Val,
            fact3Val: rtnLim.fact3Val
          }
          this.select = rtnLim
          this.$http
            .get(expandURI(apiUrl, expand))
            .then((result) => {
              this.selectedRtnLim.accmType = rtnLim.accmType
              this.selectedRtnLim.fact1Val = rtnLim.fact1Val
              this.selectedRtnLim.fact2Val = rtnLim.fact2Val
              this.selectedRtnLim.fact3Val = rtnLim.fact3Val
              this.selectedRtnLim.limType = rtnLim.limType
              this.selectedRtnLim.effDate = rtnLim.effDate
              this.promptRemove = true
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.fieldMessage(data)
                this.notify(data)
              }
            })
        }
      }
    },
    doClearFilters() {
      this.resetValidator()
      this.resetMessages()
      this.filters.accmType = undefined
      this.filters.fact1Val = undefined
      this.filters.fact2Val = undefined
      this.filters.fact3Val = undefined
      this.filters.limType = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetValidator()
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  mixins: [TableConst.default, MessageMixin, commonMixins, commonAjaxMixin]
}
</script>
